import script from "./CastomInput.vue?vue&type=script&setup=true&lang=js"
export * from "./CastomInput.vue?vue&type=script&setup=true&lang=js"

import "./CastomInput.vue?vue&type=style&index=0&id=73244626&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-73244626"]])

export default __exports__